import { debug } from "svelte/internal";
import { origin } from "../stores/variables";
import { logout } from "./logout";
import { get } from "svelte/store";

export const request = {
	controllers: [],

	checkStringsValidity(arr) {
		arr.forEach(str => {
			if (!str) {
				throw "the argument must be present";
			}
			if (typeof str != "string") {
				throw "argument must be string";
			}
		})
	},
	checkObjectsValidity(arr) {
		arr.forEach(obj => {
			if (obj === Object(obj) && Object.prototype.toString.call(obj) !== '[object Array]') {
			} else {
				if (!obj) {
					throw "the argument must be present";
				} else {
					throw "argument must be Object";
				}
			}
		})
	},
	checkFormsValidity(arr) {
		arr.forEach(form => {
			if (!form) {
				throw "the argument must be present";
			}
			if (form.tagName != "FORM") {
				throw "argument must be FORM";
			}
		})
	},

	async fetchLocalData(url, opts = {}) {
		this.checkStringsValidity([url]);
		this.checkObjectsValidity([opts]);

		url = "json/" + url + ".json";
		let response = await fetch(url);
		if (response.error) throw response.error;
		let json = await response.json();
		if (json.error) throw json.error;
		if (opts.callback) opts.callback.call(null);
		return json.data;
	},

	async DaData(raw, lenght, type) {
		if (type) {
			if (!this.controllers[type]) {
				const controller = this.controllers[type] = new AbortController();
			} else {
				this.controllers[type].abort();
				delete this.controllers[type];
				const controller = this.controllers[type] = new AbortController();
			}
		}
		let url =
			"https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
		let tkn = "b0ec6873e358249c1816df0103e4c445cd826819";
		let data = await fetch(url, {
			signal: this.controllers[type].signal,
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Token " + tkn,
			},
			body: JSON.stringify({ query: raw, count: lenght }),
		});
		let json = await data.json();
		return json;
	},

	async getAjaxData(url, opts = {}, type) {
		if (type) {
			if (!this.controllers[type]) {
				const controller = this.controllers[type] = new AbortController();
			} else {
				this.controllers[type].abort();
				delete this.controllers[type];
				const controller = this.controllers[type] = new AbortController();
			}
		}
		url = origin + url;
		var settings = {
			signal: this.controllers[type].signal,
			method: "GET",
			mode: "cors",
			credentials: "include",
		}
		Object.assign(settings, opts);
		let data = await fetch(url, settings);

		let json = await data.json();
		if (json.error) {
			loading.set(false);
		}
		return json;
	},

	async fetchData(url, type, obj = {}, opts = {}, form) {
		this.checkStringsValidity([url, type]);
		this.checkObjectsValidity([opts, obj]);
		if (form) this.checkFormsValidity([form]);

		if (!this.controllers[type]) {
			const controller = this.controllers[type] = new AbortController();
		} else {
			this.controllers[type].abort();
			delete this.controllers[type];
			const controller = this.controllers[type] = new AbortController();
		}

		let options = {
			signal: this.controllers[type].signal,
			method: "POST",
			mode: "cors",
			credentials: "include",
			path: "api/v1/",
			headers: {},
			// callback: false // function () {}
		}
		if (opts) {
			Object.keys(opts).forEach(key => {
				options[key] = opts[key]
			})
		}

		if (form) {
			let formData = new FormData(form);
			formData.append('json', JSON.stringify(obj));
			options.body = formData;
		} else if (obj) {
			let text = JSON.stringify(obj);
			if (text.length > 2) {
				options.body = text;
				options.headers['Content-Type'] = 'application/json'
			}
		}

		url = origin + options.path + url;
		let response = await fetch(url, options);
		if (response.status == 401) return logout();
		if (response.error) throw response.error;
		let json = await response.json();
		if (json.error) throw json.error
		return json;
	},
}